import { Pipe, PipeTransform } from '@angular/core';
import { TipoPraticaPipe } from './tipo-pratica.pipe';

@Pipe({
    name: 'searchFilter'
})
export class FilterSearchPipe implements PipeTransform {

  constructor(private tipoPraticaPipe: TipoPraticaPipe) {}

  transform(value: any, searchItem: string, attrValue: string, initSearch: string): any {

    if (searchItem.length === 0){
      return value;
    }

    let startSearch: number;
    if (!initSearch){
      startSearch = 0;
    } else {
      startSearch = Number(initSearch);
    }
    if (searchItem.length >= startSearch){
      if (!searchItem || searchItem.length === 0){
        return value;
      } else {
        searchItem = searchItem.toUpperCase();
        return searchItem ?
        value.filter(objectList => {
          let objTemp = objectList;
          let element: any = '';
          let elementsArray = attrValue.split('+');
          for (let entryEl of elementsArray) {
            let someArray = entryEl.split('.');
            for (let entryAt of someArray) {
              if (objTemp) {
                  objTemp = objTemp[entryAt];
                }
            }
            if (objTemp) {
              element = element + ' ' + objTemp;
            }
            objTemp = objectList;
          }
          element = this.tipoPraticaPipe.transform(element.trim());
          return element ? element.toUpperCase().indexOf(searchItem) !== -1 : element;
        })
        : value;
      }
    } else {
        return value;
    }
  }
}
